import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export interface FavoritePlacementSuccessMessageProps {
  onClick?: () => void;
}

export function FavoritePlacementSuccessMessage(props: FavoritePlacementSuccessMessageProps) {
  const { onClick } = props;
  return (
    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- Existing pattern, would require refactoring
    <Box role="button" tabIndex={0} onClick={onClick}>
      <Text sx={{ color: "white" }}>
        Visit the{" "}
        <Text sx={{ display: "inline", color: "white", textDecoration: "underline" }}>
          My Jobs Tab
        </Text>{" "}
        to view saved jobs.
      </Text>
    </Box>
  );
}
